import Bind from 'bind.js';
import Config from 'config';
import stringToDom from 'string-to-dom';
import merge from 'deepmerge';
import Register from '../Register';

export default class BuyNow {
  constructor({parentElement, data}) {
    this.parentElement = parentElement;
    this.data = data;
    this.addPriceBoxTemplate();
    this.addPrices();
  }

  addPriceBoxTemplate() {
    let template = `<div class="buynow-prices"></div>`;

    this.parentElement.insertAdjacentHTML("afterbegin", template);
  }

  getOptionLabel(key) {
    switch(key) {
      case 'user': return 'Users';
      case 'project': return 'Projects';
      case 'teams': return 'Teams';
      case 'displays': return 'Displays';
      case 'library': return 'GB';
      default : return;
    }
  }

  getOptionKey(key) {
    switch(key) {
      case 'user': return 'numberOfUsers';
      case 'project': return 'numberOfProjects';
      case 'teams': return 'numberOfTeams';
      case 'displays': return 'numberOfDisplays';
      case 'library': return 'storage';
      default : return;
    }
  }

  updatePrice(element, currentPrice, amountChange) {
    element.innerHTML = currentPrice + parseInt(amountChange);
  }

  addPrices() {
    let prices = this.data.get('prices').toJS();

    prices.forEach((price) => {
      price.selectedOption = 0;
    });

    this.buynow = Bind(
      {prices: prices},
      {
        prices: function(prices) {
          if (this.xobj && this.xobj.length > 0) {
            for (var i = 0; i < this.xobj.length; i++) {
              this.xobj[i].abort();
            }
          }

          this.xobj = [];
          var buyNowContainer = this.parentElement.getElementsByClassName('buynow-prices')[0];

          buyNowContainer.innerHTML = "";

          for (let i = 0; i < prices.length; i ++) {
            let price = prices[i];

            let displayOptions = document.createElement("div");

            let selectDisplay = "none";

            let col = (i % 2) ? "even col" : "odd";

            let buttonLabel = price.amount > 0 ? "Buy Now" : "Get it for free";

            let elementTemplate = `<div class="span6 prices ${col}">
              <div class="price-box">
                <div class="title">${price.name}</div>
                <div class="price">&pound;<span class="price_num">${price.amount}</span></div>
                <div class="frequency">per month</div>
                <div class="user-options">
                </div>
                <button class="register-button">${buttonLabel}</button>
                <div class='no-credit'>No credit needed</div>
              </div>
            </div>`;

            var priceEl = stringToDom(elementTemplate);
            var pricesEl = document.getElementsByClassName('buynow-prices')[0];
            pricesEl.appendChild(priceEl);

            this.xobj[i] = new XMLHttpRequest();
            this.xobj[i].overrideMimeType("application/json");
            this.xobj[i].index = i;
            this.xobj[i].open("GET", Config.BACKEND_URL + '/retrieveLicence/' + price.licenceId);
            this.xobj[i].onreadystatechange = function () {
              if (this.xobj[i].readyState == 4) {
                if (this.xobj[i].status == "200") {
                  let licence = JSON.parse(this.xobj[i].response);

                  var pricesEl = this.parentElement.getElementsByClassName('buynow-prices')[0];

                  var priceEl = pricesEl.childNodes[this.xobj[i].index];

                  var registerButton = priceEl.getElementsByClassName('register-button')[0];

                  registerButton.dataset.dynamic = JSON.stringify({});

                  registerButton.onclick = function(event) {
                    window.location = "/addons.html?id=" + licence.ID;
                    localStorage.setItem(licence.ID + "-dynamic", event.target.dataset.dynamic);

                    if (licence.trialPeriod > 0) {
                      localStorage.setItem(licence.ID + "-trial", licence.trialPeriod);
                    } else {
                      localStorage.setItem(licence.ID + "-trial", 0);
                    }
                  }

                  if (licence.trialPeriod > 0) {
                    registerButton.innerHTML = "Try it for free";
                  }

                  var limits = JSON.parse(licence.limits);

                  for (var key in limits.dynamic) {
                    var limit = limits.dynamic[key];

                    var dynamicOptionsEl = priceEl.getElementsByClassName('user-options')[0];
                    
                    if (limit.enable && limit.items.length > 1) {

                      var selectLicence = document.createElement('select');
                      selectLicence.className = "select-options"

                      let selectOptions = priceEl.getElementsByClassName('selectOptions');
                      var priceAmountEl = priceEl.getElementsByClassName('price_num')[0];

                      for (let j =0; j < limit.items.length; j++) {
                        var item = limit.items[j];
                        var option = document.createElement("option");
                        var optionKey = this.getOptionKey(key);
                        var optionLabel = this.getOptionLabel(key);
                        option.value = j;
                        option.text = item[optionKey] + " " + optionLabel;
                        option.dataset.item = JSON.stringify(item);
                        option.dataset.optionKey = item[optionKey];
                        option.dataset.key = key;
                        option.dataset.amountChange = item.amountChange;

                        selectLicence.appendChild(option);

                      }

                      var options = priceEl.getElementsByClassName('select-options');
                      var selectedOption = selectLicence.selectedOptions[0];
                      selectLicence.dataset.amountChange = selectedOption.dataset.amountChange;

                      var currentDynamic = JSON.parse(registerButton.dataset.dynamic);
                      registerButton.dataset.dynamic = this.updateDynamicProperties(key, currentDynamic, selectedOption);

                      selectLicence.onchange = (event) => {
                        var options = priceEl.getElementsByClassName('select-options');

                        this.updatePrice(priceAmountEl,
                                         parseInt(priceAmountEl.innerHTML),
                                         event.target.dataset.amountChange * -1);

                        var selectedOption = event.target.selectedOptions[0];
                        event.target.dataset.amountChange = event.target.selectedOptions[0].dataset.amountChange;

                        var key = selectedOption.dataset.key;
                        var currentDynamic = JSON.parse(registerButton.dataset.dynamic);
                        registerButton.dataset.dynamic = this.updateDynamicProperties(key, currentDynamic, selectedOption);

                        this.updatePrice(priceAmountEl, parseInt(priceAmountEl.innerHTML),
                                         event.target.dataset.amountChange);
                      }

                      this.updatePrice(priceAmountEl,
                                       parseInt(priceAmountEl.innerHTML),
                                       selectLicence.selectedOptions[0].dataset.amountChange);

                      dynamicOptionsEl.appendChild(selectLicence);
                    }
                  }
                }
              }
            }.bind(this);
            this.xobj[i].setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            this.xobj[i].send();
          }
        }.bind(this)
      }
    );
  }

  updateDynamicProperties(key, currentDynamicProperties, selectedOption) {
    var jsonSave = {};
    jsonSave[key] = {};

    jsonSave[key][this.getOptionKey(key)] = selectedOption.dataset.optionKey;

    return JSON.stringify(merge(currentDynamicProperties, jsonSave));
  }

  reRender(data) {
    this.data = data;

    this.buynow.prices = data.get('prices').toJS();
  }
}



// WEBPACK FOOTER //
// ./src/renderers/BuyNow.js